import useTracking from "./Tracking.hook";

export default useTracking;
